<script>
const { VUE_APP_API_HOST } = process.env  

export default {
  methods: {
    login(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/login`, body)
        .then(res => res, err => err)
    },
    forgotPassword(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/forgot`, body)
        .then(res => res, err => err)
    },
    resetPassword(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/reset`, body)
        .then(res => res, err => err)
    }
  }
}
</script>